
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/jtb-cwt",
      function () {
        return require("private-next-pages/cases/jtb-cwt/index.tsx");
      }
    ]);
  